export default materialKey => materialKey !== 'iron_grey';



// WEBPACK FOOTER //
// ./src/utils/isNotIronGray.js